/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Source_Profile_LabelInputs */

const en_subtitle_import_source_profile_label = /** @type {(inputs: Subtitle_Import_Source_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source Profile`)
};

const fr_subtitle_import_source_profile_label = /** @type {(inputs: Subtitle_Import_Source_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil source`)
};

const de_subtitle_import_source_profile_label = /** @type {(inputs: Subtitle_Import_Source_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellenprofil`)
};

const it_subtitle_import_source_profile_label = /** @type {(inputs: Subtitle_Import_Source_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo sorgente`)
};

const ru_subtitle_import_source_profile_label = /** @type {(inputs: Subtitle_Import_Source_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профиль источника`)
};

const es_subtitle_import_source_profile_label = /** @type {(inputs: Subtitle_Import_Source_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil de la fuente`)
};

const zh_cn2_subtitle_import_source_profile_label = /** @type {(inputs: Subtitle_Import_Source_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来源概况`)
};

const ja_subtitle_import_source_profile_label = /** @type {(inputs: Subtitle_Import_Source_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースプロファイル`)
};

const hi_subtitle_import_source_profile_label = /** @type {(inputs: Subtitle_Import_Source_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत प्रोफ़ाइल`)
};

const pt_pt2_subtitle_import_source_profile_label = /** @type {(inputs: Subtitle_Import_Source_Profile_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil da fonte`)
};

/**
* | output |
* | --- |
* | "Source Profile" |
*
* @param {Subtitle_Import_Source_Profile_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_source_profile_label = /** @type {((inputs?: Subtitle_Import_Source_Profile_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Source_Profile_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_source_profile_label(inputs)
	if (locale === "de") return de_subtitle_import_source_profile_label(inputs)
	if (locale === "it") return it_subtitle_import_source_profile_label(inputs)
	if (locale === "ru") return ru_subtitle_import_source_profile_label(inputs)
	if (locale === "es") return es_subtitle_import_source_profile_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_source_profile_label(inputs)
	if (locale === "ja") return ja_subtitle_import_source_profile_label(inputs)
	if (locale === "hi") return hi_subtitle_import_source_profile_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_source_profile_label(inputs)
	return en_subtitle_import_source_profile_label(inputs)
});